import { useCallback, useState } from 'react'

/** Tracks the id of the title that currently names a dialog surface, so `aria-labelledby` never points at a missing element. */
export const useTitleLabel = () => {
  const [labelId, setLabelId] = useState<string>()

  const registerTitle = useCallback((id: string) => {
    setLabelId(id)

    return () => setLabelId((current) => (current === id ? undefined : current))
  }, [])

  return { labelId, registerTitle }
}
